import React, { useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import api from '../../api/api';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import '../../components/BackgroundPattern/BackgroundHeader.css'

const RequestedUser = () => {
  const [displaySidebar, setDisplaySidebar] = useState(true);
  const [requestedUsers, setRequestedUsers] = useState();
  const [allStations, setAllStations] = useState([]);
  const[showLoader,setShowLoader]=useState(false);
  const [errorModalFlag, setErrorModalFlag] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  
  
  let userType;
  const toggleSideBar = () => {
    setDisplaySidebar(!displaySidebar);
  };
  const navigate = useNavigate();
  const fetchInfo = useCallback(async () => {
    api
      .get('api/users/show_requested_user/', {
        headers: {
          'Content-Type': 'application/json',
            'X-CSRFToken': '{{ csrf_token }}',
        },
      })
      .then((response) => {
        setAllStations(response.data.all_stations);
        setRequestedUsers(response.data);
      })
      .catch((error) => {
        console.log(error);
        setErrorModalFlag(true)
        setErrorMsg(error.message)
        // navigate('/Home');
      });
  }, []);

  useEffect(() => {
    fetchInfo();
    const handleResize = () => {
      if (window.innerWidth < 991) {
        setDisplaySidebar(false);
      } else {
        setDisplaySidebar(true);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fetchInfo]);

  const handleApproval = (e, id) => {
    e.preventDefault();
    setShowLoader(true);
    const apiUrl = `api/users/user_requested/${id}/`;
    api
      .post(
        apiUrl,
        {
          q: 'APPROVE',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': '{{ csrf_token }}',
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      }).finally(()=>{
        setShowLoader(false);
      })
  };
  const handleDenial = (e, id) => {
    e.preventDefault();
    setShowLoader(true);
    const apiUrl = `api/users/user_requested/${id}/`;
    api
      .post(
        apiUrl,
        {
          q: 'DENY',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': '{{ csrf_token }}',
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      }).finally(()=>{
        setShowLoader(false);
      })
  };
  return (
    <div className="page-body">
      <div className="loader">
      {
        showLoader && <Loader></Loader>
      }
      </div>
      
      <div>
        
        <Navbar toggleSideBar={toggleSideBar}/>
      </div>
      <div
        style={{
          marginLeft:
            displaySidebar === true
              ? window.innerWidth > 991
                ? '230px'
                : '0px'
              : '0px',
        }}
        
      >
        {requestedUsers != null ? (
          <div>
            {requestedUsers.user_requested.length === 0 ? (
              <div style={{display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              color: 'blue',
              minHeight: '60vh'}}>
                No Users Requests available!
              </div>
            ) : (
              <div className='flex flex-wrap'>
                {requestedUsers.user_requested.map(function (user, i) {
                  {console.log(user)}
                  return (
                    <div className="col-sm-6 m-4 max-w-sm" key={user.id}>
                      <div className="card rounded shadow">
                        <div className="card-body">
                          <h5 className="card-title">
                            User:- {user.first_name} {user.last_name}{' '}
                            {user.user_l_name}
                          </h5>
                          <p className="card-text">Email:- {user.email}</p>
                          <p className="card-text">Phone:- {user.phone_number}</p>
                          
                          <p className="card-text">Role:- {user.user_type}</p>
                          <p className="card-text">Division:- {user.division}</p>
                          <p className="card-text">Depot:- {user.depo}</p>
                          <div className='max-w-xs mt-2 mb-2 overflow-y-scroll h-36'>
                            {user.train_details &&(<div className='max-w-xs'>
                                <h5>Trains Added</h5>
                                <table className='w-full'>
                                <thead>
                                    <tr>
                                    <th>Train Number</th>
                                    <th>Coaches</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(user.train_details).map(([trainNumber, coaches]) => (
                                    <tr key={trainNumber}>
                                        <td>{trainNumber}</td>
                                        <td>
                                        {coaches.join(', ')}
                                        </td>
                                    </tr>
                                    ))}
                                </tbody>
                                </table>
                            </div>)}
                          </div>
                          <div style={{ display: 'flex' }}>
                            <div className="button-container">
                              <button
                                type="submit"
                                className="btn btn-success"
                                name="q"
                                value="APPROVE"
                                onClick={(e) => handleApproval(e, user.id)}
                              >
                                Approve
                              </button>
                              <button
                                type="submit"
                                className="btn btn-danger"
                                name="q"
                                value="DENY"
                                onClick={(e) => handleDenial(e, user.id)}
                              >
                                Deny
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ) : (
          <div className="flex justify-center items-center text-blue-400 min-h-screen">
            Loading....
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestedUser;
